import { useCallback, useEffect, useState } from 'react';
import { isAxiosError } from 'axios';

import { getAgreementData } from '@VDL/api';
import { useVDLStore } from '@VDL/store/VDLstore';

import type { IVDLAgreement } from '@VDL/api/types/IVDLAgreement';

export const useFetchAgreement = () => {
  const [data, setData] = useState<IVDLAgreement[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const { setAgreementData } = useVDLStore();

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    setData([]);
    setAgreementData([]);

    try {
      const response = await getAgreementData();

      setData(response.data);
      setAgreementData(response.data);
    } catch (error) {
      if (isAxiosError(error)) setError(error.message);
      else console.error(error);
    } finally {
      setLoading(false);
    }
  }, [setAgreementData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, fetchData, loading, error };
};
